import { render, staticRenderFns } from "./addGifts.vue?vue&type=template&id=7fe316cb&scoped=true"
import script from "./addGifts.vue?vue&type=script&lang=js"
export * from "./addGifts.vue?vue&type=script&lang=js"
import style0 from "./addGifts.vue?vue&type=style&index=0&id=7fe316cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe316cb",
  null
  
)

export default component.exports